import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import type { Conversation } from '../model/types'

import { useCurrentId } from './useCurrentId'

export function useSelectFirstChat(first?: Conversation) {
	const conversation = useCurrentId()
	const navigate = useNavigate()
	const location = useLocation()

	useEffect(() => {
		if (!conversation && first) {
			const { entity_id: id } = first
			navigate({ pathname: `./thread/${id}`, search: location.search }, { replace: true })
		}
	}, [navigate, location.search, conversation, first])
}
